// @flow
import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import styled from 'styled-components'
import { openContactModal } from '../../actions/modals'
import Button from '../../components/Button'
import PageHeader from '../../components/PageHeader'
import FaqTabs from '../../components/FaqTabs'
import LinkButton from '../../components/LinkButton'

const GetInTouch = styled.div`
  border-left: 1px solid rgb(220, 225, 230);
  padding-left: 2rem;
`

type Props = {
  openContactModal: Function
}

const Faq = (
  { openContactModal }: Props // eslint-disable-line no-shadow
) => (
  <div>
    <Helmet title="FAQ" />
    <PageHeader text="FAQ's" />
    <FaqTabs />
    <div style={{ padding: '4rem 0' }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-xs-12" style={{ marginBottom: '1rem' }}>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li>
                <strong>Is Kief Realty a real estate brokerage?</strong>
                <p>
                  Yes, Kief Realty is a fully licensed, full service residential
                  real estate brokerage currently servicing East Central
                  Illinois.
                </p>
              </li>
              <li>
                <strong>Where are you located?</strong>
                <p>Kief Realty is headquartered in Paxton, Illinois.</p>
              </li>
              <li>
                <strong>What areas do you service?</strong>
                <p>
                  You can view the markets we serve on the bottom of our
                  homepage, <Link to="/">click here to see them</Link>.
                </p>
              </li>
              <li>
                <strong>Where do Kief Realty’s listings come from?</strong>
                <p>
                  The listings displayed on our search page are pulled directly
                  from Multiple Listing Services.
                </p>
              </li>
              <li>
                <strong>Who can use Kief Realty to buy a home?</strong>
                <p>
                  If you are qualified to purchase a home, then Kief Realty will
                  be able to help you.
                </p>
              </li>
              <li>
                <strong>
                  How do I know if I’m qualified to purchase a home?
                </strong>
                <p>
                  We can help you with some of the preliminary qualifying
                  debt-to-income calculations, but it’d be best for you to visit
                  with a lender or mortgage officer to fully determine your
                  eligibility for a home loan and evaluate the various loan
                  program options available to you. We have plenty of excellent
                  lenders and mortgage officers that we can put you in contact
                  with.
                </p>
              </li>
              <li>
                <strong>
                  Why does Kief Realty need to require an office visit or verify
                  my identity before my first home tour?
                </strong>
                <p>
                  Kief Realty requires this step in order to preserve the safety
                  of our team.
                </p>
              </li>
              <li>
                <strong>
                  Will I work with an individual Kief Realty agent?
                </strong>
                <p>
                  You may work with one or all of our team members at one point
                  or another throughout your home buying experience. Our team
                  will provide whatever customer service is necessary to ensure
                  that your transaction is as efficient and stress free as
                  possible.
                </p>
              </li>
              <li>
                <strong>Can I meet my Kief Realty agent first?</strong>
                <p>
                  Yes, you can. You can schedule an office visit by giving us a
                  call at (217) 379-2222 or{' '}
                  <LinkButton type="button" onClick={openContactModal}>
                    shoot us a message here
                  </LinkButton>
                  .
                </p>
              </li>
              <li>
                <strong>What if I am already working with an agent?</strong>
                <p>
                  If you already have an agency relationship with an agent from
                  another brokerage, we cannot assist you at this time. That
                  relationship would need to be openly, honestly and legally
                  terminated before you seek a new agency agreement with Kief
                  Realty or any other brokerage.
                </p>
              </li>
              <li>
                <strong>
                  How does my offer get submitted to the listing agent?
                </strong>
                <p>
                  When you submit an offer from our website or in person, your
                  designated buyer’s agent will assist you in completing your
                  offer packet. Kief Realty will then submit and present your
                  offer to the listing agent on your behalf.
                </p>
              </li>
              <li>
                <strong>Can I buy a home that I found on another site?</strong>
                <p>
                  Yes you can. Please reach out to us at (217) 379-2222 or fill
                  out a{' '}
                  <LinkButton type="button" onClick={openContactModal}>
                    contact form here
                  </LinkButton>{' '}
                  to tell us about it and discuss your options.
                </p>
              </li>
              <li>
                <strong>
                  Does touring a home with Kief Realty obligate me in any way to
                  work with you?
                </strong>
                <p>
                  Not at all! Of course, with our expertise and ability to
                  provide value, we feel we are a top choice for anyone looking
                  to buy and sell homes.
                </p>
              </li>
              <li>
                <strong>Does my offer commit me to buying a property?</strong>
                <p>
                  Electronically submitted offers from our website do not
                  obligate you to complete the transaction. This only initiates
                  the offer packet. Nothing has been submitted to the seller or
                  seller’s agent at that point.
                </p>
              </li>
              <li>
                <strong>
                  If I submit an offer from your website, are you obligated to
                  work with me?
                </strong>
                <p>
                  No, Kief Realty is not. If you have not yet established an
                  agency relationship with us, we would need to discuss and
                  address that before moving forward.
                </p>
              </li>
              <li>
                <strong>I want to sell my house, how do I get started?</strong>
                <p>
                  You can either call us at (217) 379-2222 or fill out a contact
                  form <Link to="/sell">here</Link>. We will be in touch within
                  30 minutes during normal office hours.
                </p>
              </li>
              <li>
                <strong>How can you offer a rebate?</strong>
                <p>
                  We are compensated by the seller’s broker or seller when
                  representing a buyer that purchases a home. From that
                  commission, Kief Realty rebates a portion to our buyer client.
                </p>
              </li>
              <li>
                <strong>
                  Does the rebate work with VA, FHA and USDA programs?
                </strong>
                <p>
                  Unfortunately these loan programs may have restrictions. We
                  will notify our buyer clients upfront if there will be any
                  restrictions with their loan program and our rebate.
                </p>
              </li>
              <li>
                <strong>
                  Does Kief Realty have a minimum purchase price limit?
                </strong>
                <p>
                  No, not at this time. However, to receive the full $250
                  rebate, we do have a minimum commission requirement of $2,500.
                </p>
              </li>
              <li>
                <strong>
                  For rebate purposes, how is the minimum commission determined?
                </strong>
                <p>
                  The minimum commission is based off of what Kief Realty has
                  determined as an appropriate revenue to cover its cost and
                  margin target, while also granting the $250 rebate.
                </p>
              </li>
              <li>
                <strong>How and when do I receive my commission rebate?</strong>
                <p>
                  If your rebate is applied toward any part of your closing
                  costs, then you would realize your rebate in your settlement
                  figures when you close on your home purchase. There would be
                  no physical check in this instance. If you plan to receive
                  your commission rebate via check, it will be mailed or hand
                  delivered to you within 7 days from the close of your home
                  purchase.
                </p>
              </li>
            </ul>
          </div>
          <div className="col-lg-4 col-xs-12">
            <GetInTouch>
              <h5>Get in touch</h5>
              <p>
                Have questions? Please feel free to give us a call at (217)
                379-2222 or send a message anytime. Our Kief Realty team members
                are happy to assist you with your home buying and selling needs.
              </p>
              <Button
                color="primary"
                onClick={openContactModal}
                style={{ dispaly: 'block', width: '100%' }}
              >
                Contact us
              </Button>
            </GetInTouch>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default connect(
  null,
  { openContactModal }
)(Faq)



// WEBPACK FOOTER //
// ./src/views/Faq/index.js